import { env } from '~/shared/config'

/**
 * Default HTTP timeout in milliseconds
 */
export const DEFAULT_HTTP_TIMEOUT = 10_000 // 10 seconds

/**
 * HTTP timeout in milliseconds
 */
export const HTTP_TIMEOUT = Number.isFinite(env.TRIA_CLIENT_HTTP_TIMEOUT)
  ? env.TRIA_CLIENT_HTTP_TIMEOUT
  : DEFAULT_HTTP_TIMEOUT

/**
 * Retries count (1 means -> 1 request + 1 retry)
 */
export const MAX_RETRIES = 1

/**
 * Limit time for all retries combined,
 * this is essentially a total timeout for single request, with all retries under the hood included
 */
export const TOTAL_RETRY_LIMIT_MILLIS = 1 * 60 * 1000 // 1 min

/**
 * Maximum backoff a single retry is allowed to wait for
 */
export const MAX_RETRY_DELAY = 1 * 60 * 1000 // 1 min
